import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, MenuItem, styled, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from 'react-hook-form';
import * as yup from "yup";
import { useCreateRoleReviewMutation, useFetchRoleReviewsByEmployeeQuery } from "../../../services/roleReviewService";
import useAuth from "../../../hooks/useAuth";
import { Link, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFetchCurrentUserQuery } from "../../../services/profileService";
import { jwtDecode } from "jwt-decode";

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  title: yup.string().required("Title is required"),
  organization: yup.string().required("Organization is required"),
  date: yup.date().required("Date is required"),
  purpose: yup.string().required("Purpose is required"),
  preparedBy: yup.string().required("Prepared by is required"),
  // jobSummary: yup.string().required("Job Summary is required"),
  jobSummary: yup
    .string()
    .required("Job Summary is required")
    .max(1000, "Job Summary cannot exceed 1000 characters"),
});

const Step1 = ({ currentStep, onNext,onPrev }) => {
  const {users} = useAuth()
  
  // const userId=useParams();
  const { id: param } = useParams();
 
  // let employeeId;
  const [employeeId, setEmployeeId] = useState(null);
  useEffect(() => {
    if (users?.role === "manager") {
      if (param.includes(".")) {
        try {
          const decoded = jwtDecode(param); // Decode JWT token
          setEmployeeId(decoded?.user_id);
          // Set employeeId in state
          console.log(decoded?.user_id); // Extract user ID from token
        } catch (error) {
          console.error("Invalid token:", error);
          setEmployeeId(null);
        }
      } else {
        setEmployeeId(param);
         // If not a token, use the param as employee ID
      }
    } else {
      setEmployeeId(users?.user_id); // Use logged-in user ID for non-managers
    }
  }, [users, param]);
  console.log(employeeId)
 
  // if (users?.role === "manager") {
    
  //   // employeeId=userId.id
  //   if (param.includes(".")) {
  //     // If param includes a dot (.), it's likely a JWT token
  //     try {
  //       const decoded = jwtDecode(param); // Decode the token
  //       employeeId = decoded?.user_id; // Extract user ID from the token
  //     } catch (error) {
  //       console.error("Invalid token:", error);
  //       employeeId = null; // Handle invalid token case
  //     }
  //   } else {
  //     // If not a token, assume it's a normal ID
  //     employeeId = param;
  //   }
  // } else {
  //   employeeId = users?.user_id; // Use the logged-in user's ID for non-managers
  // }
  const { data: roleReviewData } =useFetchRoleReviewsByEmployeeQuery(employeeId);
  // console.log("roleReviewData",roleReviewData?.data[0])
  
  const [createRoleReview] = useCreateRoleReviewMutation();
  const { data: currentUser,refetch } = useFetchCurrentUserQuery(employeeId);
  
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      title: "",
      organization: "",
      // date: "",
      date: new Date(),
      purpose: "",
      preparedBy: "",
      jobSummary: "",
    },
    resolver: yupResolver(validationSchema),
  });
  // useEffect(() => {
  //   if (formValue) {
  //     setValue('name', formValue.name);
  //     setValue('title', formValue.title);
  //     setValue('organization', formValue.organization);
  //     setValue('date', new Date());  // Assuming the date format is compatible
  //     setValue('purpose', formValue.purpose);
  //     setValue('preparedBy', formValue.prepared_by);
  //     setValue('jobSummary', formValue.job_summary);
  //   }
  // }, [formValue, setValue]);
  useEffect(() => {
    refetch()
    if (currentUser) {
      // Set the fields using the fetched current user data
      setValue('name', currentUser?.data?.name); // Auto-fill the name from current user data
      setValue('preparedBy', `${currentUser?.data?.name} <${currentUser?.data?.email}>`); // Auto-fill prepared by with name and email
      setValue('organization', currentUser?.data?.company_name); // Auto-fill company name (organization)
      setValue('title', currentUser?.data?.job_title); // Auto-fill job summary from role review data
      setValue('date', new Date()); 
      setValue('purpose', currentUser?.data?.purpose);// Auto-fill today's date
      setValue('jobSummary', roleReviewData?.data[0]?.job_summary);
    }
  }, [currentUser, refetch,roleReviewData, setValue]);
  const onSubmit =async (data) => {
    try {
      const requestData = {
        user_id: employeeId,
        name: data.name,
        title: data.title,
        organization: data.organization,
        date: data.date,
        purpose: data.purpose,
        prepared_by: data.preparedBy, // Convert to snake_case
        job_summary: data.jobSummary, // Convert to snake_case
      };
      await createRoleReview(requestData);
      // console.log("Role review created successfully:", response);
      onNext(); // Proceed to the next step
    } catch (error) {
      console.error("Failed to create role review:", error);
      // Handle error (e.g., show an error message to the user)
    }

    // onNext();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormMiddleBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
        <RowWrap>
          <Col6Wrap>
            <FormGroupWrap>
              <FormLabelWrap>Name</FormLabelWrap>
              <CustomTextField
                variant="outlined"
                {...register("name")}
                placeholder="Enter Name"
              />
              {errors.name && <ErrorText>{errors.name.message}</ErrorText>}
            </FormGroupWrap>
          </Col6Wrap>
          <Col6Wrap>
            <FormGroupWrap>
              <FormLabelWrap>Job Title</FormLabelWrap>
              <CustomTextField
                variant="outlined"
                {...register("title")}
                placeholder="Title"
              />
              {errors.title && <ErrorText>{errors.title.message}</ErrorText>}
            </FormGroupWrap>
          </Col6Wrap>
          <Col6Wrap>
            <FormGroupWrap>
              <FormLabelWrap>Organization</FormLabelWrap>
              <CustomTextField
                variant="outlined"
                {...register("organization")}
                placeholder="Organization Name"
              />
              {errors.organization && (
                <ErrorText>{errors.organization.message}</ErrorText>
              )}
            </FormGroupWrap>
          </Col6Wrap>
          <Col6Wrap>
            <FormGroupWrap sx={{ "& .react-datepicker-wrapper": { width: '100%' }  }}>
              <FormLabelWrap>Date</FormLabelWrap>
              
              <Controller
                name="date"
                control={control}
                render={({ field }) => (
                  <Box sx={{ width: '100%' }}>
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="mm/dd/yyyy"
                      className="custom-datepicker"
                      customInput={<CustomTextField variant="outlined" />}
                    />
                  </Box>
                )}
              />
             
              {/* <CustomTextField
                sx={{
                  "& .MuiInputBase-input": {
                    cursor: 'pointer',
                  }
                }}
                variant="outlined"
                type="date"
                {...register("date")}
                placeholder="Date"
              /> */}
              {errors.date && <ErrorText>{errors.date.message}</ErrorText>}
            </FormGroupWrap>
          </Col6Wrap>
          <Col6Wrap>
            <FormGroupWrap>
              <FormLabelWrap>Purpose</FormLabelWrap>
              {/* <CustomTextField
                variant="outlined"
                {...register("purpose")}
                placeholder="Purpose"
              /> */}
              
              <Controller
                name="purpose"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    fullWidth
                    sx={{ width: "99%",
                      border: "1px solid #DADADA",
                      borderRadius: "7px",
                      "& .MuiInputBase-input": {
                        fontSize: "16px",
                        fontWeight: "300",
                        color: "#2C2C2E",
                        padding: "14px 20px",
                      },
                      "& fieldset": {
                        border: "none",
                      }, }}
                  >
                    <MenuItem value="">Select Purpose</MenuItem>
                    <MenuItem value="New Role Design/Development">New Role Design/Development</MenuItem>
                    <MenuItem value="Onboarding">Onboarding</MenuItem>
                    <MenuItem value="Performance Management">Performance Management</MenuItem>
                    <MenuItem value="Succession Planning/Retirement">Succession Planning/Retirement</MenuItem>
                    <MenuItem value="Delegate & Elevate">Delegate & Elevate</MenuItem>
                  </TextField>
                )}
              />
              {errors.purpose && (
                <ErrorText>{errors.purpose.message}</ErrorText>
              )}
            </FormGroupWrap>
          </Col6Wrap>
          <Col6Wrap>
            <FormGroupWrap>
              <FormLabelWrap>Prepared by</FormLabelWrap>
              <CustomTextField
                variant="outlined"
                {...register("preparedBy")}
                placeholder="Prepared by"
               
              />
              {errors.preparedBy && (
                <ErrorText>{errors.preparedBy.message}</ErrorText>
              )}
            </FormGroupWrap>
          </Col6Wrap>
        </RowWrap>
      </FormMiddleBoxWrap>
      <FormLastBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
        <RowWrap>
          <Col12Wrap>
            <FormGroupWrap>
              {/* <FormLabelWrap
                sx={{
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#000000",
                }}
              >
                Job Summary:
              </FormLabelWrap> */}
               <CustomHead>What do you do here? </CustomHead>
              <FormLabelWrap
                sx={{
                  fontSize: "20px",
                  color: "#7C7C7C",
                  letterSpacing: "0.3px",
                  marginBottom: "10px",
                }}
              >
                Describe the importance of your role within this organization
              </FormLabelWrap>
              <FormLabelWrap
                sx={{
                  fontSize: "20px",
                  color: "#7C7C7C",
                  letterSpacing: "0.3px",
                  marginBottom: "10px",
                }}
              >
                If needed, there is a short video to guide you.{" "}
                <Link
                  to="https://youtu.be/z7PPP-7L14Q"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "#1976d2", textDecoration: "underline", fontWeight: "bold" }}
                >
                  Click here to watch video
                </Link>
              </FormLabelWrap>
              <CustomTextField
                variant="outlined"
                {...register("jobSummary")}
                multiline
                rows={3}
                placeholder="Job Summary..."
              />
              {errors.jobSummary && (
                <ErrorText>{errors.jobSummary.message}</ErrorText>
              )}
            </FormGroupWrap>
          </Col12Wrap>
        </RowWrap>
      </FormLastBoxWrap>
      <FormBtnBoxWrap>
        <RowWrap>
          <Col12Wrap sx={{ textAlign: "center" }}>
            <CustomBtn
              type="submit"
              variant="outlined"
              sx={{ "& svg": { marginLeft: "10px" } }}
            >
              Next
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289L8.34315 0.928932C7.95262 0.538407 7.31946 0.538407 6.92893 0.928932C6.53841 1.31946 6.53841 1.95262 6.92893 2.34315L12.5858 8L6.92893 13.6569C6.53841 14.0474 6.53841 14.6805 6.92893 15.0711C7.31946 15.4616 7.95262 15.4616 8.34315 15.0711L14.7071 8.70711ZM1 9L14 9L14 7L1 7L1 9Z"
                  fill="white"
                />
              </svg>
            </CustomBtn>
          </Col12Wrap>
        </RowWrap>
      </FormBtnBoxWrap>
    </form>
  );
};

export default Step1;

const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "50%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 767px)": {
    width: "100%",
  },
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormLastBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  borderRadius: "0px 0px 7px 7px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "30px",
  position: "relative",
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#2C2C2E",
  marginBottom: "5px",
}));
const CustomTextField = styled(TextField)(() => ({
  width: "99%",
  border: "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const CustomHead = styled(Typography)(() => ({
  fontSize: "26px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#1085AB",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "22px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  // padding: "19px 20px",
  // maxWidth: "300px",
  padding: "10px 15px",
  maxWidth: "150px",
  boxShadow: "none !important",
}));
const ErrorText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#ff0000",
  marginTop: "5px",
}));

